import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LayoutComponent  } from './layout.component';

import { LayoutRoutingModule } from './layout-routing.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '../material';
import { NgxBarcodeModule } from 'ngx-barcode';

import { ExcelService } from 'src/ExportExcel/excel.service';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
@NgModule({
  declarations: [
    LayoutComponent
 
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserModule,
    ToastrModule.forRoot(),
    LayoutRoutingModule,
    RouterModule,
    CommonModule,
    NgxBarcodeModule,
    NgbModule,
    BrowserAnimationsModule,
    MaterialModule,
    
  ],
  
  providers: [ExcelService],
  bootstrap: []
})
export class LayoutModule { }
